import { render, staticRenderFns } from "./PayV3.vue?vue&type=template&id=6e48fdba&scoped=true&"
import script from "./PayV3.vue?vue&type=script&lang=js&"
export * from "./PayV3.vue?vue&type=script&lang=js&"
import style0 from "./PayV3.vue?vue&type=style&index=0&id=6e48fdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48fdba",
  null
  
)

export default component.exports